module.exports = __webpack_public_path__ + "img/bg_avatar_female_21.45e4ca14.png";